import { Header, Screen } from '@components'
import { usePaginateMemories } from '@hooks'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import React from 'react'
import {
  Dimensions,
  Image,
  NativeScrollEvent,
  NativeSyntheticEvent,
  StyleSheet,
  TouchableOpacity,
  View,
} from 'react-native'
import { ScrollView } from 'react-native-gesture-handler'

const width = Dimensions.get('window').width

export const TaggedMemories: React.FC = (): React.ReactElement => {
  const theme = useTheme()
  const styles = getStyle(theme, width)
  const { data, isPending, fetchNextPage } = usePaginateMemories()
  const memories = data?.pages.flatMap((page) => page.data) || []

  const handleScroll = async (event: NativeSyntheticEvent<NativeScrollEvent>) => {
    const { layoutMeasurement, contentOffset, contentSize } = event.nativeEvent

    const isCloseToBottom = layoutMeasurement.height + contentOffset.y >= contentSize.height - 20
    if (isCloseToBottom) {
      await fetchNextPage()
    }
  }

  return (
    <Screen isPending={isPending}>
      {/* @TODO design */}
      <Header iconColor={theme.colors.secondary} title="Tagged memories" />

      <ScrollView style={styles.container} onScroll={handleScroll} scrollEventThrottle={400}>
        <View style={styles.imagesContainer}>
          {memories.map((memory, index) => (
            <TouchableOpacity key={index} style={styles.imageContainer}>
              <Image style={styles.image} source={{ uri: memory.url }} />
            </TouchableOpacity>
          ))}
        </View>
      </ScrollView>
    </Screen>
  )
}

const getStyle = (theme: Theme, width: number) =>
  StyleSheet.create({
    container: {
      paddingVertical: theme.spacing.lg,
      flex: 1,
    },
    imagesContainer: {
      flexWrap: 'wrap',
      flexDirection: 'row',
    },
    imageContainer: {
      width: width / 3,
      height: width / 3,
    },
    image: {
      width: '100%',
      height: '100%',
    },
  })
